var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4 w-4/12 h-7  bg-gray-200 rounded-full dark:bg-gray-700"},[_c('div',{staticClass:"h-7 rounded-full",style:({ width: _vm.width, backgroundColor : _vm.color})})])}
var staticRenderFns = []

export { render, staticRenderFns }